import SignupHeroImage from "@public/signup-hero.png";
import TextLogo from "@public/text-logo.svg";
import Image from "next/image";
import type { FC, ReactNode } from "react";
import { SignupAlertBanner } from "./SignupAlertBanner";
import { SignupStepBar, type Step } from "./SignupStepBar";

const ALERT_MESSAGE =
  "GmailやSlackなどのアプリ内でリンクを開いた場合、正常に登録できないことがあります。Google ChromeやSafariなどのブラウザを直接開いて、新規登録を行ってください。";

export const SignupLayout: FC<{
  currentStep: Step;
  showHeroSection?: boolean;
  children: ReactNode;
}> = ({ currentStep, showHeroSection = true, children }) => {
  return (
    <div className="flex min-h-screen flex-col">
      <SignupAlertBanner message={ALERT_MESSAGE} />

      {/* ヒーローセクション: イラスト（左） + 説明テキスト・ロゴ（右） */}
      {showHeroSection && (
        <div className="flex h-24 items-center justify-center bg-primary-0.5">
          <div className="relative flex h-full w-full max-w-2xl items-center">
            <div
              className="absolute top-0 left-0 h-24 w-44 sm:hidden"
              style={{
                maskImage:
                  "linear-gradient(to right, black 15%, transparent 60%)",
              }}
            >
              <Image
                src={SignupHeroImage}
                alt=""
                fill
                sizes="176px"
                className="object-cover"
                style={{ objectPosition: "340% 50%" }}
                priority
              />
            </div>
            {/* デスクトップ */}
            <div className="relative hidden h-24 w-48 shrink-0 sm:block">
              <Image
                src={SignupHeroImage}
                alt=""
                fill
                sizes="192px"
                className="object-contain"
                priority
              />
            </div>
            <div className="relative z-10 flex justify-center pr-4 pl-20 sm:px-4">
              {/* デスクトップ */}
              <p className="hidden text-sm font-bold text-monotone-7 sm:block">
                VCスタートアップ健保の会員サイト「mykenpo」では、
                <br />
                <span className="text-primary-6">
                  各種届出や健診補助、資格情報、特典サービス
                </span>
                などを確認できます。
              </p>
              {/* モバイル */}
              <p className="text-sm font-bold text-monotone-7 sm:hidden">
                「mykenpo」では、
                <span className="text-primary-6">
                  各種届出や健診補助、資格情報、特典サービス
                </span>
                などを確認できます。
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="mx-auto flex w-full max-w-130 flex-1 flex-col items-center gap-8 px-6 pt-10 pb-16 sm:gap-10 sm:pt-12 sm:pb-20">
        {/* ロゴ */}
        <TextLogo
          aria-label="VCスタートアップ健康保険組合"
          width={326}
          height={32}
          viewBox="0 0 286 28"
        />

        {/* ステップバー */}
        <div className="w-full">
          <SignupStepBar currentStep={currentStep} />
        </div>

        <div className="h-0.5 w-full bg-primary-6" />

        {/* コンテンツ */}
        <div className="w-full flex-1">{children}</div>
      </div>
    </div>
  );
};
